import { api } from '@/shared/lib/api'
import type { ObjectiveWithProgress } from '@/types/objective'

/**
 * O endpoint é paginado com o default do Pagy (20 itens) e aceita `per_page`.
 * Sem enviá-lo, um evento com 22 objetivos ativos — o caso auditado, com duas
 * escadas e um objetivo solto — perde degraus na resposta, e a escada chega
 * incompleta ao card. Esta tela depende da lista completa para agrupar/contar
 * objetivos client-side (bug objectives-list-count-mismatch).
 * O produtor já envia `per_page: 100` na listagem dele.
 */
const OBJECTIVES_PER_PAGE = 500

export async function fetchObjectives(
  eventSlug: string
): Promise<ObjectiveWithProgress[]> {
  const { data } = await api.get<{ records: ObjectiveWithProgress[] }>(
    `/user/digital_products/${eventSlug}/objectives`,
    { params: { per_page: OBJECTIVES_PER_PAGE } }
  )
  return data.records ?? []
}
